export interface LoadDocumentType {
  id: number;
  description: string;
}
